import useSWR from 'swr';
import { getReferralByCreator } from '../../helpers';

const useUserCreatedReferral = (address: string | null | undefined) => {
    const { data, error, mutate } = useSWR(
        address ? ['userCreatedReferral', address] : null,
        async (_, userAddress) => {
            const referral = await getReferralByCreator(userAddress);

            return referral.status === 404 ? '' : referral.data.code;
        }
    );

    return {
        userCreatedReferral: data,
        isLoading: !error && data !== '' && !data,
        error,
        mutate,
    };
};

export default useUserCreatedReferral;
